module.exports = __webpack_public_path__ + "img/组-49.9ef5f4af.png";